import * as Sentry from '@sentry/react';
import config from 'react-native-ultimate-config';
export default function initSentry() {
    Sentry.init({
        dsn: config.SENTRY_DSN,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
            'localhost',
            /^https:\/\/marinesamraj\.com/,
            /^https:\/\/preprod\.marinesamraj\.com/,
        ],
        // Session Replay — Free plan allows 50 replays/month; keep sampling low.
        replaysSessionSampleRate: 0, // No random session replays; save quota for errors.
        replaysOnErrorSampleRate: 0.1, // Sample ~10% of sessions that hit an error.
        enabled: config.NODE_ENV !== 'development',
    });
}
